import { UnknownAction } from 'redux';
import {
  CallActionTypes,
  FETCH_CALLS_REQUEST,
  FETCH_CALLS_SUCCESS,
  FETCH_CALLS_FAILURE,
  SET_CALL_SEARCH_TERM,
  SET_CALL_CURRENT_PAGE,
} from '../actions/callActions';
import { CallData, PaginationData } from '../../services/types';

export interface CallState {
  calls: CallData[];
  pagination: PaginationData | null;
  loading: boolean;
  error: string | null;
  searchTerm: string;
  currentPage: number;
}

const initialState: CallState = {
  calls: [],
  pagination: null,
  loading: false,
  error: null,
  searchTerm: '',
  currentPage: 1,
};

const callReducer = (state = initialState, action: UnknownAction): CallState => {
  const typedAction = action as CallActionTypes;
  switch (typedAction.type) {
    case FETCH_CALLS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CALLS_SUCCESS:
      return {
        ...state,
        loading: false,
        calls: typedAction.payload.calls,
        pagination: typedAction.payload.pagination,
        error: null,
      };

    case FETCH_CALLS_FAILURE:
      return {
        ...state,
        loading: false,
        error: typedAction.payload,
        calls: [],
      };

    case SET_CALL_SEARCH_TERM:
      return {
        ...state,
        searchTerm: typedAction.payload,
        currentPage: 1, // Reset to first page when searching
      };

    case SET_CALL_CURRENT_PAGE:
      return {
        ...state,
        currentPage: typedAction.payload,
      };

    default:
      return state;
  }
};

export default callReducer;

